var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 31",
    style: {
      enableBackground: "new 0 0 35 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st5{fill:#FFFFFF;}\n\t.st1{fill:#3DB12B;}\n\t.st2{fill:#47AF2E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34.9,25.5l-8-3.7h-6.7v-3.2H28V4.3c0-0.4-0.3-0.7-0.7-0.7H13.7c-0.4,0-0.7,0.3-0.7,0.7v14.3h2.7v3.2h-3.8 c-1.2,0-2.2-1-2.2-2.2V3.2c0-1.6,1.3-2.9,2.9-2.9h15.7c1.6,0,2.9,1.3,2.9,2.9v14.2L34.9,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.7,14.4v10.8c0,1.6-1.3,2.9-2.9,2.9H6.7L0,30.7l3.1-5.4V14.4c0-1.6,1.3-2.9,2.9-2.9h3.1v3.2H6.7 c-0.2,0-0.4,0.2-0.4,0.4v9.7h9.7c0.2,0,0.4-0.2,0.4-0.4v-9.3c0-0.2-0.2-0.4-0.4-0.4h-2.5v-3.2h3.2C18.4,11.5,19.7,12.8,19.7,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.5,16c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8C24.1,15.1,24.5,15.5,24.5,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.1,16c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8S27.1,15.5,27.1,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.9,16c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8C21.5,15.1,21.9,15.5,21.9,16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo2);
export default __webpack_public_path__ + "static/media/BrandLogo2.5b5ca5d9ee726d4df03c10ce25c4f36e.svg";
export { ForwardRef as ReactComponent };